module.exports = __webpack_public_path__ + "static/media/sam-icon.97977c77.png";